<template>
    <div>
        <div class="ppv2-flex ppv2-justify-between ppv2-items-start">
            <!-- Text Content -->
            <div class="ppv2-flex-1" style="max-width: 55rem">
                <div class="ppv2-flex ppv2-gap-4 ppv2-items-center ppv2-mb-4">
                    <button
                        class="ppv2-text-black ppv2-w-[42px] ppv2-h-[42px] ppv2-rounded-xl ppv2-border ppv2-border-solid ppv2-border-black ppv2-border-opacity-20 ppv2-flex ppv2-items-center ppv2-justify-center ppv2-cursor-pointer hover:ppv2-shadow-md transition"
                        style="flex-shrink: 0"
                        aria-label="Retour"
                        v-if="pages.includes(page)"
                        @click="$emit('back-action')"
                    >
                        <ArrowLeft :size="24" />
                    </button>
                    <div class="ppv2-flex ppv2-flex-col ppv2-gap-2">
                        <h2 class="poppinsRegular ppv2-text-black ppv2-mb-0" :style="{ fontSize: normalizeFontSize(26) }">
                            <div v-if="breadcrumb && breadcrumb.length" class="ppv2-flex ppv2-items-center ppv2-gap-2">
                                <div v-for="(crumb, idx) in breadcrumb">
                                    <span
                                        :key="'crumb-' + idx"
                                        :style="{
                                            fontSize: normalizeFontSize(19) + 'px',
                                        }"
                                        >{{ crumb }}</span
                                    >
                                    <span
                                        v-if="idx < breadcrumb.length - 1"
                                        :key="'sep-' + idx"
                                        :style="{ fontSize: normalizeFontSize(18) + 'px', margin: '0 4px', color: '#cbd2dc' }"
                                        >&gt;</span
                                    >
                                </div>
                            </div>
                            <template v-else>{{ title }}</template>
                        </h2>
                        <p
                            v-if="!pages.includes(page) && subtitle"
                            class="poppinsBold ppv2-text-black ppv2-text-opacity-60 ppv2-mb-0"
                            :style="{ fontSize: normalizeFontSize(15) }"
                        >
                            {{ subtitle }}
                        </p>
                        <p
                            class="poppinsRegular ppv2-text-black ppv2-text-opacity-60 ppv2-mb-0 whitespace-pre-line"
                            :style="{ fontSize: normalizeFontSize(15) }"
                            v-if="description"
                        >
                            {{ description }}
                        </p>
                    </div>
                </div>

                <!-- Info Box -->
                <div
                    v-if="infoMessage"
                    class="ppv2-flex ppv2-items-center ppv2-bg-white ppv2-rounded-3xl ppv2-p-3 ppv2-mt-4 ppv2-max-w-xl"
                >
                    <img src="/v2/images/img_group_53.svg" alt="info" class="ppv2-w-5 ppv2-h-5 ppv2-mr-2" />
                    <span class="poppinsRegular ppv2-text-black" :style="{ fontSize: normalizeFontSize(15) }">
                        {{ infoMessage }}
                    </span>
                </div>
            </div>

            <!-- Progress Circle -->
            <!-- <ProgressCircle v-if="progressPercentage !== null" :percentage="progressPercentage" class="ppv2-ml-8" /> -->
        </div>
    </div>
</template>

<script>
import ProgressCircle from './ProgressCircle.vue'
import normalizeSize from '../../utils/normalizeSize'
import normalizeFontSize from '../../utils/normalizeFontSize'
import Header from './Header.vue'
import { ArrowLeft } from 'lucide-vue'

export default {
    name: 'ConfigurationHeader',
    components: { ProgressCircle, Header, ArrowLeft },
    props: {
        page: { type: String, default: '' },
        title: { type: String, required: true },
        subtitle: { type: String, required: false },
        description: { type: String, required: false },
        infoMessage: { type: String, default: '' },
        progressPercentage: { type: Number, default: null },
        breadcrumb: { type: Array, default: null },
    },
    data() {
        return {
            pages: ['Info', 'ResourcePlanning', 'FinancialBilling'],
        }
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>
<style scoped>
.bgConfigHeader {
    background-color: #efeffd80;
}

.dark .bgConfigHeader {
    background-color: #2c2c2ce5;
}
</style>
